import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { LayoutSplashScreen } from '_metronic/layout';
import { FEATURE_FLAGS } from 'app/constants/FeatureFlag';
import { ROUTES_PATH } from 'app/constants/Routes';
import useFeatureFlag from 'app/hooks/useFeatureFlag';
import useCustomerSatisfactionSurvey from 'app/hooks/useCustomerSatisfactionSurvey';
import DriveFrame from './DriveFrame';

// Tempo de permanência na página antes de oferecer a pesquisa de satisfação —
// quem só passa pela tela não é perguntado. O cooldown de reexibição continua
// sendo do backend (GET /csat/drive).
const CSAT_DELAY_MS = 15_000;

export const MeuDrive: React.FC = () => {
  const { isFeatureFlagEnable: isDriveEnabled, flagResolved } = useFeatureFlag(
    FEATURE_FLAGS.KILL_SWITCH.ENABLE_DRIVE_FRONT,
  );

  const csatSurveyFn = useCustomerSatisfactionSurvey(
    'drive',
    'Como você avalia a sua experiência com o Meu Drive?',
  );

  useEffect(() => {
    if (!isDriveEnabled) return undefined;

    const timer = setTimeout(() => csatSurveyFn(), CSAT_DELAY_MS);

    return () => clearTimeout(timer);
  }, [isDriveEnabled]);

  if (!flagResolved) {
    return <LayoutSplashScreen />;
  }

  if (!isDriveEnabled) {
    return <Redirect to={ROUTES_PATH.MAIN.DASHBOARD} />;
  }

  return <DriveFrame />;
};
